<template>

  <div>
  <el-dialog title="添加排行榜" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" ref="form" :model="form">
      <el-form-item label="排行耪名称" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="name">
         <el-input v-model="form.name"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="排行榜图片" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="image_url">
          <el-row>
            <el-button icon="el-icon-upload" @click="openUpload">选择图片</el-button>
            <div v-if="form.image_id > 0" class="img mt10"><img :src="form.image_url" width="100" height="100" /></div>
          </el-row>
          <div class="gray">图片为2M以内大小，格式限png，jpg格式
          <span>建议尺寸：750x360；</span>
          </div>
      </el-form-item>
      
      <el-form-item label="数据源" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="source_id">
        <el-input v-model="form.source.name" disabled class="max-w460"></el-input>
        <el-button type="primary"  @click="selectLink()">选择数据源</el-button>
        <div >数据源说明（不需要操作，专业技术人员添加调整）</div>
      </el-form-item>
      <el-form-item label="排行榜主体名称" :label-width="formLabelWidth"  >
         <el-input v-model="form.setting.ranking_name"  placeholder="" class="max-w460"></el-input>
         <div >示例：产品名称 给产品做排行（不需要操作，专业技术人员添加调整）</div>
      </el-form-item>
      <el-form-item label="数据名称" :label-width="formLabelWidth" >
         <el-input v-model="form.setting.ranking_value"  placeholder="" class="max-w460"></el-input>
         <div >示例：销售数量/件 根据销量排行（不需要操作，专业技术人员添加调整）</div>
      </el-form-item>
      
      <el-form-item label="排序" :label-width="formLabelWidth">
         <el-input v-model="form.sort"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="是否开启：" :label-width="formLabelWidth">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="add" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    <Source :issource="issource" @closeDialog="closeDialogFunc"></Source>
  </div>
</template>

<script>
  import RankingApi from '@/api/ranking.js';
  import Upload from '@/components/file/Upload';
  import Source from '@/components/ranking/Source';
  export default {
    components: {
      Source,
      Upload
    },
    data() {
      return {
        issource:false,
        /*是否上传图片*/
        isupload: false,
        open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        user:{},
        form: {
          source:{},
          name: '',
          source_id:0,
          data_link:'',
          sort: '100',
          status: '',
          image_url: '',
          image_id: '',
          setting:{
            ranking_name:'名称',
            ranking_value:'销售数量/件',
            list_rows:15,
          }
        },
      };
    },
    props: ['open_add'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
        /*上传*/
      openUpload(e) {
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.image_url = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
      /*修改用户*/
      add() {
        let self = this;

        let params = self.form;
        console.log(params)
        
        
         self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
              RankingApi.Add(params, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，操作成功',
                    type: 'success'
                  });
                  self.dialogFormVisible(true);
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
        
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      closeDialogFunc(e) {
        console.log(e)
        let self = this;
        self.issource = false;
        if (e.type == 'success') {
          var source = {
            name:e.params[0].name,
            source_id:e.params[0].source_id,
          }
          self.form.source = source
          self.form.source_id = source.source_id
        }
    },
    /*打开添加*/
    selectLink() {
      this.issource = true;
    },

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ranking/index/dialog/Add.vue